import { ReactNode } from 'react';
import clsx from 'clsx';

interface ParagraphProps {
  children: ReactNode;
  className?: string;
  fontBold?: boolean;
  fontMedium?: boolean;
  lightColor?: boolean;
}

const Paragraph = ({
  children,
  className,
  fontBold = false,
  fontMedium = false,
  lightColor = false,
}: ParagraphProps) => {
  return (
    <p
      className={clsx(
        'text-[1.6rem] leading-[2.2rem] [&_strong]:font-extrabold xlup:text-[1.8rem] xlup:leading-[2.4rem] text-primary',
        { 'font-bold': fontBold },
        { 'font-medium': !fontBold },
        { 'text-[#89ABA4]': lightColor },
        { 'text-primary': !lightColor },
        className,
      )}>
      {children}
    </p>
  );
};

export default Paragraph;
